import {AuthConfig} from 'angular-oauth2-oidc';
import {environment as devEnv} from '../../../environments/environment';
import {environment as prodEnv} from '../../../environments/environment.prod';

//TODO: this line should break the app because window only available in browser
const isLocalEnv = window.location.host.includes('localhost');

const issuer = isLocalEnv
    ? devEnv.endpoints.identity
    : prodEnv.endpoints.identity;

const redirectUri = isLocalEnv
    ? `${devEnv.endpoints.baseUrl}/index.html`
    : `${prodEnv.endpoints.baseUrl}/index.html`;

const postLogoutRedirectUri = isLocalEnv
    ? `${devEnv.endpoints.baseUrl}/index.html`
    : `${prodEnv.endpoints.baseUrl}/index.html`;

const clientId = isLocalEnv ? 'dev.mobile.client' : 'mobile.client';

export const authCodeFlowConfig: AuthConfig = {
    issuer,
    redirectUri,
    clientId,
    responseType: 'code',
    scope: 'openid profile api userinfo offline_access',
    // showDebugInformation: true,
    postLogoutRedirectUri,
    requestAccessToken: true,
};
